import { Scale, Building2, Server, Copyright, Mail } from "lucide-react";
import { SEO } from "@/components/SEO";

export default function MentionsLegalesPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="mentions-legales-page">
      <SEO
        title="Mentions Légales - Mediastore Niort"
        description="Mentions légales du site mediastore79.com : éditeur, hébergeur, propriété intellectuelle. Mediastore, réparation iPhone, Mac et ordinateurs à Niort."
        path="/mentions-legales"
        breadcrumbs={[
          { name: "Accueil", path: "/" },
          { name: "Mentions Légales", path: "/mentions-legales" },
        ]}
      />

      <section className="py-16 md:py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-slate-100 text-slate-700 px-4 py-2 rounded-full mb-6">
              <Scale className="h-5 w-5" />
              <span className="font-semibold">Informations légales</span>
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">Mentions Légales</h1>
            <p className="text-slate-600">
              Conformément à la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l&apos;économie numérique (LCEN).
            </p>
          </div>
        </div>
      </section>

      <section className="pb-20">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto space-y-10">

            <div data-testid="mentions-editeur">
              <h2 className="text-base md:text-lg font-bold text-slate-900 flex items-center gap-2 mb-3">
                <Building2 className="h-5 w-5 text-red-600" />
                1. Éditeur du site
              </h2>
              <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 space-y-1 text-sm text-slate-700">
                <p><strong>Dénomination :</strong> Mediastore</p>
                <p><strong>Activité :</strong> Réparation de téléphones, tablettes et ordinateurs — Vente de produits reconditionnés</p>
                <p><strong>Adresse :</strong> 104 Rue de la Gare, 79000 Niort, France</p>
                <p><strong>Téléphone :</strong> <a href="tel:+33549057490" className="text-red-600 hover:underline">05 49 05 74 90</a></p>
                <p><strong>E-mail :</strong> <a href="mailto:imediastore79@gmail.com" className="text-red-600 hover:underline">imediastore79@gmail.com</a></p>
                <p><strong>Directeur de la publication :</strong> Le gérant de Mediastore</p>
              </div>
            </div>

            <div data-testid="mentions-hebergeur">
              <h2 className="text-base md:text-lg font-bold text-slate-900 flex items-center gap-2 mb-3">
                <Server className="h-5 w-5 text-red-600" />
                2. Hébergement
              </h2>
              <p className="text-sm text-slate-700 leading-relaxed">
                Le site <strong>www.mediastore79.com</strong> est hébergé par Emergent (emergent.sh),
                infrastructure cloud sécurisée. Les données sont hébergées dans des centres de données
                conformes aux standards de sécurité en vigueur.
              </p>
            </div>

            <div data-testid="mentions-propriete">
              <h2 className="text-base md:text-lg font-bold text-slate-900 flex items-center gap-2 mb-3">
                <Copyright className="h-5 w-5 text-red-600" />
                3. Propriété intellectuelle
              </h2>
              <p className="text-sm text-slate-700 leading-relaxed">
                L&apos;ensemble du contenu de ce site (textes, images, logos, tarifs, structure) est la
                propriété exclusive de Mediastore, sauf mention contraire. Toute reproduction,
                représentation, modification ou diffusion, totale ou partielle, sans autorisation
                écrite préalable est interdite et constituerait une contrefaçon sanctionnée par les
                articles L.335-2 et suivants du Code de la propriété intellectuelle.
              </p>
              <p className="text-sm text-slate-700 leading-relaxed mt-3">
                Les marques Apple, iPhone, iPad, Mac, MacBook, Samsung, Huawei, Xiaomi et autres
                marques citées sont la propriété de leurs détenteurs respectifs. Mediastore est un
                réparateur indépendant et n&apos;est pas affilié à ces marques.
              </p>
            </div>

            <div data-testid="mentions-responsabilite">
              <h2 className="text-base md:text-lg font-bold text-slate-900 flex items-center gap-2 mb-3">
                <Scale className="h-5 w-5 text-red-600" />
                4. Responsabilité
              </h2>
              <p className="text-sm text-slate-700 leading-relaxed">
                Les informations diffusées sur ce site (tarifs, délais, disponibilités) sont fournies
                à titre indicatif et peuvent être modifiées à tout moment. Un devis personnalisé est
                systématiquement établi avant toute intervention. Mediastore ne saurait être tenu
                responsable des dommages directs ou indirects résultant de l&apos;utilisation de ce site.
              </p>
            </div>

            <div data-testid="mentions-contact">
              <h2 className="text-base md:text-lg font-bold text-slate-900 flex items-center gap-2 mb-3">
                <Mail className="h-5 w-5 text-red-600" />
                5. Nous contacter
              </h2>
              <p className="text-sm text-slate-700 leading-relaxed">
                Pour toute question relative aux présentes mentions légales, vous pouvez nous
                contacter par e-mail à{" "}
                <a href="mailto:imediastore79@gmail.com" className="text-red-600 hover:underline">imediastore79@gmail.com</a>{" "}
                ou par téléphone au <a href="tel:+33549057490" className="text-red-600 hover:underline">05 49 05 74 90</a>.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}
